import { BOTONES } from '../../../../componentes/botones';
import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { IEventoGenerico, IValoresEventoEmergencia } from 'modelos/src';
import { CardHeaderComponent } from '../../../../componentes/card-header/card-header.component';
import { ContentCardComponent } from '../../../../componentes/content-card/content-card.component';
import { MapaFacilV2Component } from '../../../../auxiliares/mapbox/mapa-facil-v2.component';
import mapboxgl from 'mapbox-gl';
import {
  IPresentacion,
  presentacionEstado,
} from '../../../entidades/emergencias/estado-emergencia';
import type { IEventoProcesado } from '../seguimientos/seguimiento.component';

@Component({
  selector: 'app-seguimiento-detalles-modal',
  templateUrl: './detalles.component.html',
  styleUrls: ['./detalles.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,
    BOTONES,
    MatCardModule,
    CardHeaderComponent,
    ContentCardComponent,
    MapaFacilV2Component,
  ],
})
export class EventoDetallesModalComponent implements OnInit {
  dialogRef = inject<MatDialogRef<EventoDetallesModalComponent>>(MatDialogRef);
  data = inject<{
    evento: IEventoProcesado;
  }>(MAT_DIALOG_DATA);

  /** Color, ícono y nombre del estado, de la paleta única. */
  public presentacion: IPresentacion = presentacionEstado(
    this.data?.evento?.estado,
  );

  private marker: mapboxgl.Marker | null = null;

  ngOnInit(): void {}

  get valores(): IValoresEventoEmergencia | undefined {
    const evento = this.data?.evento;
    if (!evento) return undefined;

    return evento.valores as IValoresEventoEmergencia;
  }

  get tieneUbicacion(): boolean {
    return !!this.valores?.ubicacionActual?.coordinates;
  }

  get coordenadas(): [number, number] | null {
    const coords = this.valores?.ubicacionActual?.coordinates;
    if (coords && coords.length >= 2) {
      return [coords[0], coords[1]];
    }
    return null;
  }

  onMapReady(map: mapboxgl.Map): void {
    if (this.coordenadas) {
      // Agregar marker en la ubicación
      this.marker = new mapboxgl.Marker({ color: this.presentacion.color })
        .setLngLat(this.coordenadas)
        .addTo(map);

      // Forzar resize del mapa después de que el dialog alcance su tamaño final
      // Esto corrige el problema de que el marker se desplace al hacer zoom
      setTimeout(() => {
        map.resize();
        // Centrar el mapa en la ubicación con animación suave
        map.flyTo({
          center: this.coordenadas!,
          zoom: 15,
          essential: true,
        });
      }, 100);
    }
  }

  cerrar(): void {
    this.dialogRef.close();
  }
}
